import founderMaaz from '../assets/founder-maaz.jpg';

// Curated carpet/rug images from Unsplash and source-specific external references.
// Keep source rights in mind when replacing or redistributing third-party media.

const IMAGES = {
  // Product card images — each showing a different rug, all verified
  products: [
    'https://images.unsplash.com/photo-1600166898405-da9535204843?w=600&q=80',       // 1: Gold traditional rug with tassels
    'https://images.unsplash.com/photo-1560185127-6ed189bf02f4?w=600&q=80',           // 2: Colorful woven textile
    'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=600&q=80',       // 3: Interior with rug
    'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=600&q=80',        // 4: Modern interior warm tones
    'https://images.unsplash.com/photo-1615529182904-14819c35db37?w=600&q=80',        // 5: Artisan textile weaving
    'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&q=80',        // 6: Interior with patterned rug
  ],

  // Hero / lifestyle images
  hero: 'https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=1600&q=80',
  heroSlides: [
    'https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=1600&q=80',
    'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1600&q=80',
    'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=1600&q=80',
    'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1600&q=80',
  ],
  heroLogin: 'https://images.unsplash.com/photo-1546550879-3b71f2427ae0?w=1200&q=80',

  // Room images
  livingRoom: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=900&q=80',
  bedroom: 'https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=600&q=80',
  diningRoom: 'https://images.unsplash.com/photo-1617806118233-18e1c696e578?w=600&q=80',

  // Story / Brand section
  story: 'https://images.unsplash.com/photo-1597665863042-47e00964d899?w=1200&q=80',

  // Bhadohi references: Carpet Expo Mart (official CEPC media) + artisan process visuals
  bhadohiExpoMartHall: 'https://www.cepc.co.in/wp-content/uploads/2021/02/IMG_9019.jpg',
  bhadohiExpoMartFront: 'https://www.cepc.co.in/wp-content/uploads/2021/02/IMG_9015.jpg',
  bhadohiExpoMartInterior: 'https://www.cepc.co.in/wp-content/uploads/2020/12/4-1.jpg',
  bhadohiTraditionWeaving: 'https://images.pexels.com/photos/32673642/pexels-photo-32673642.jpeg?auto=compress&cs=tinysrgb&w=1600&h=1000&dpr=1',
  bhadohiHeritageLoom: 'https://images.pexels.com/photos/8931819/pexels-photo-8931819.jpeg?auto=compress&cs=tinysrgb&w=1600&h=1000&dpr=1',
  bhadohiSkillProcess: 'https://images.pexels.com/photos/31508152/pexels-photo-31508152.jpeg?auto=compress&cs=tinysrgb&w=1600&h=1000&dpr=1',

  // Founder portrait from local src assets (bundled by Vite)
  founderPortrait: founderMaaz,

  // Product detail — larger version
  productDetail: 'https://images.unsplash.com/photo-1600166898405-da9535204843?w=800&q=80',

  // Cart thumbnail
  cartThumb: 'https://images.unsplash.com/photo-1600166898405-da9535204843?w=200&q=80',
};

export default IMAGES;
